/* src/app/pages/user-profile/user-profile.page.scss */
.mt-8 {
  margin-top: 8px;
}
/*# sourceMappingURL=user-profile.page.css.map */
